import React from "react";
import { useDispatch, useSelector } from "react-redux";
import BookCard from "../components/Book/BookCard";
import { useGetBooksQuery } from "../features/api/apiSlice";
import { changeStatus } from "../features/filters/fiterSlice";

const Home = () => {
  const { isError, isLoading, data: books } = useGetBooksQuery();

  const { status, searchTerm } = useSelector((state) => state.filters);
  const dispatch = useDispatch();

  const filterBooksBySearchTerm = (book) => {
    if (book?.name.toLowerCase().includes(searchTerm?.toLowerCase())) {
      return true;
    }
  };

  const filterByStatus = (book) => {
    switch (status) {
      case "Featured":
        return book.featured;
      default:
        return true;
    }
  };

  let content = null;

  if (isLoading) content = <p>Loading...</p>;
  if (!isLoading && isError) content = <p>Some error occured!</p>;
  if (!isLoading && !isError && books?.length === 0)
    content = <p>No books found!</p>;
  if (!isLoading && !isError && books?.length > 0) {
    content = books
      ?.filter(filterBooksBySearchTerm)
      .filter(filterByStatus)
      .map((book) => <BookCard key={book.id} book={book} />);
  }

  return (
    <>
      <main className="py-12 px-6 2xl:px-6 container">
        <div className="order-2 xl:-order-1">
          <div className="flex items-center justify-between mb-12">
            <h4 className="mt-2 text-xl font-bold">Book List</h4>

            <div className="flex items-center space-x-4">
              <button
                className={`lws-filter-btn ${status!=="Featured" && "active-filter"}`}
                onClick={() => dispatch(changeStatus(""))}
              >
                All
              </button>
              <button
                className={`lws-filter-btn ${status==="Featured" && "active-filter"}`}
                onClick={() => dispatch(changeStatus("Featured"))}
              >
                Featured
              </button>
            </div>
          </div>
          <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* <!-- Card 1 --> */}
            {content}
          </div>
        </div>
      </main>
    </>
  );
};

export default Home;
